import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  FormHelperText,
} from "@mui/material";
import {
  SaveSampleTypes,
  UpdateSampleTypes,
} from "../../../services/SamplesMaintenanceService";
import { NotificationManager } from "react-notifications";

const AddSampleTypeDialog = ({ open, onClose, editSampleType }) => {
  const [sampleType, setSampleType] = useState("");
  const [turnaround, setTurnaround] = useState(0);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    console.log("editSampleType", editSampleType);
    if (editSampleType) {
      setSampleType(editSampleType.samtype || "");
      setTurnaround(editSampleType.turnaround || 0);
    }
  }, [editSampleType]);
  const validateForm = () => {
    const errors = {};
    if (!sampleType.trim()) {
      errors.sampleType = "Sample Type is required";
    }
    if (!turnaround || isNaN(turnaround)) {
      errors.turnaround = "Turnaround is required and must be a number";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0; // Return true if there are no errors
  };


  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {
      try {
        const parsedTurnaround = parseInt(turnaround, 10);
        if (editSampleType) {
          await UpdateSampleTypes(sampleType, parsedTurnaround);
          NotificationManager.success("Sample type updated successfully");
        } else {
          await SaveSampleTypes(sampleType, parsedTurnaround);
          NotificationManager.success("Sample type added successfully");
        }
        onClose();
      } catch (error) {
        // Show a hard-coded error message regardless of the error details
        NotificationManager.error(
          "An error occurred while saving the sample type."
        );
      }
    }
  };

  const handleClose = () => {
    setSampleType("");
    setTurnaround("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Add New Sample Type</DialogTitle>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <FormControl fullWidth margin="normal" error={!!errors.sampleType}>
            <TextField
              label="Sample Type"
              value={sampleType}
              onChange={(e) => setSampleType(e.target.value)}
            />
            {errors.sampleType && (
              <FormHelperText>{errors.sampleType}</FormHelperText>
            )}
          </FormControl>
          <FormControl fullWidth margin="normal" error={!!errors.turnaround}>
            <TextField
              label="Turnaround"
              type="number"
              value={turnaround}
              onChange={(e) => setTurnaround(e.target.value)}
            />
            {errors.turnaround && (
              <FormHelperText>{errors.turnaround}</FormHelperText>
            )}
          </FormControl>
          <DialogActions>
            <Button onClick={handleClose}>Cancel</Button>
            <Button type="submit" variant="contained" color="primary">
              Save
            </Button>
          </DialogActions>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddSampleTypeDialog;
